export default {
  IS_DEV: process.env.NODE_ENV === 'development',
  baseURL: process.env.REACT_APP_BASE_URL,
  QISCUS_APP_ID: process.env.REACT_APP_QISCUS_APP_ID,
  mapsAPIKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  firebaseVapidKey: process.env.REACT_APP_FIREBASE_VAPID_ID,
  firebaseApiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  firebaseAuthDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  firebaseDBUrl: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  firebaseProjectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  firebaseStorageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  firebaseSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  firebaseAppId: process.env.REACT_APP_FIREBASE_APP_ID,
  firebaseMeasurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  defaultChatroomAvatar:
    'https://spacemonk-deployments-mobilehub-spacemonk.s3.ap-south-1.amazonaws.com/kindpng_group.png',
};
